<template>
  <div>
    <h2
      class="font-[Poppins] font-black text-[clamp(24px,3.5vw,34px)] text-[#191c1e] mb-1.5 tracking-[-0.5px]"
    >
      Designsystem
    </h2>
    <p
      class="font-[Plus_Jakarta_Sans] text-[15px] text-[#6c7a77] leading-[1.65] mb-7 max-w-[580px]"
    >
      En samlad referens för alla visuella byggstenar på Emmalagat — från färger
      och typografi till interaktiva komponenter. Används som dokumentation och
      för att säkerställa konsekvent design över hela sajten.
    </p>
    <div
      class="grid gap-3"
      style="grid-template-columns: repeat(auto-fill, minmax(190px, 1fr))"
    >
      <div
        v-for="item in statsCards"
        :key="item.label"
        class="px-5 py-4 rounded-2xl bg-white"
        style="border: 1.5px solid #eceef0"
      >
        <p
          class="font-[Poppins] font-bold text-[10px] text-[#6c7a77] tracking-[1px] uppercase mb-1"
        >
          {{ item.label }}
        </p>
        <p
          class="font-[Plus_Jakarta_Sans] font-bold text-[14px] text-[#191c1e]"
        >
          {{ item.value }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({ sectionCount: Number });
const statsCards = [
  { label: "Typsnitt", value: "Poppins + Plus Jakarta Sans" },
  { label: "Primärfärg", value: "#14b8a6 — Teal" },
  { label: "Ramverk", value: "Vue 3 + Tailwind CSS v4" },
  { label: "Ikoner", value: "lucide-vue-next + @phosphor-icons/vue" },
  { label: "Komponenter", value: `${props.sectionCount} dokumenterade` },
  { label: "Version", value: "v1.0 · 2026" },
];
</script>
